export enum magicMicrocopy {
  MAGIC_TERM_PRIVACY = 'MAGIC_TERM_PRIVACY',
  MAGIC_TERM_LOADING_TEXT = 'MAGIC_TERM_LOADING_TEXT',
}
